'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _basePopupManager = require('@bibliocommons/base-popup-manager');

var _basePopupManager2 = _interopRequireDefault(_basePopupManager);

var _baseIcons = require('@bibliocommons/base-icons');

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseMobileDropdownMenu = require('@bibliocommons/base-mobile-dropdown-menu');

var _baseMobileDropdownMenu2 = _interopRequireDefault(_baseMobileDropdownMenu);

var _dropdownMenu = require('../../dropdown-menu');

var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);

var _dropdownTrigger = require('../../dropdown-trigger');

var _dropdownTrigger2 = _interopRequireDefault(_dropdownTrigger);

require('../styles/Dropdown.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropdown = exports.Dropdown = function (_BcReactComponent) {
  _inherits(Dropdown, _BcReactComponent);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.bindAll('handleSelect', 'renderDropdownMenu');
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'handleSelect',
    value: function handleSelect(_ref) {
      var value = _ref.value;

      this.props.handleSelect(value);
    }
  }, {
    key: 'showMobileMenu',
    value: function showMobileMenu() {
      return !this.props.disableMobile && typeof window !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(window.navigator.userAgent) && this.props.options;
    }
  }, {
    key: 'renderDropdownMenu',
    value: function renderDropdownMenu(popupActions) {
      if (this.showMobileMenu()) {
        return _react2.default.createElement(_baseMobileDropdownMenu2.default, {
          selected: this.props.selected,
          options: this.props.options,
          handleSelect: this.handleSelect });
      }

      var dropdownMenuId = this.props.dropdownMenuId || _lodash2.default.uniqueId('dropdownMenu_');
      return _react2.default.createElement(
        _dropdownMenu2.default,
        {
          id: dropdownMenuId,
          right: this.props.right,
          options: this.props.options,
          handleSelect: this.handleSelect,
          closeAndFocus: popupActions.closeAndFocusContent },
        this.props.children
      );
    }
  }, {
    key: 'renderTrigger',
    value: function renderTrigger(handleToggle) {
      var expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _props = this.props,
          labelledById = _props.labelledById,
          selected = _props.selected,
          renderSelected = _props.renderSelected,
          descriptionLocalizedText = _props.descriptionLocalizedText,
          labelLocalizedText = _props.labelLocalizedText,
          isLoading = _props.isLoading,
          disabled = _props.disabled,
          renderTrigger = _props.renderTrigger;


      return _react2.default.createElement(
        _dropdownTrigger2.default,
        {
          ButtonTag: this.props.ButtonTag,
          onClick: handleToggle || function () {},
          hasPopup: true,
          labelledById: labelledById,
          className: this.props.className,
          expanded: expanded,
          labelLocalizedText: labelLocalizedText,
          descriptionLocalizedText: descriptionLocalizedText,
          testId: this.props.testId,
          isLoading: isLoading,
          disabled: disabled,
          renderTrigger: renderTrigger },
        renderSelected(selected)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          dropup = _props2.dropup,
          mountAsOpen = _props2.mountAsOpen;


      var classNames = (0, _classnames2.default)('cp-dropdown', { dropup: dropup });
      var useMobileMenu = this.showMobileMenu();

      if (useMobileMenu) {
        return _react2.default.createElement(
          'div',
          { className: classNames },
          this.renderTrigger(),
          this.renderDropdownMenu()
        );
      }

      return _react2.default.createElement(
        _basePopupManager2.default,
        {
          renderContent: this.renderDropdownMenu,
          initialOpenState: mountAsOpen,
          className: classNames,
          closeOnClick: true },
        function (popupActions, expanded) {
          return _this2.renderTrigger(popupActions.toggleContent, expanded);
        }
      );
    }
  }]);

  return Dropdown;
}(_baseBcReactComponent2.default);

var optionsShape = _react.PropTypes.shape({
  key: _react.PropTypes.string,
  label: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node, _react.PropTypes.string]),
  value: _react.PropTypes.string
});

Dropdown.propTypes = {
  ButtonTag: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_baseBcReactComponent2.default), _react.PropTypes.func]),
  children: _bcPropTypes.childrenShape,
  selected: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
  renderSelected: _react.PropTypes.func,
  options: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(optionsShape), _react.PropTypes.object, _reactImmutableProptypes2.default.listOf(optionsShape)]),
  dropup: _react.PropTypes.bool,
  right: _react.PropTypes.bool,
  isLoading: _react.PropTypes.bool,
  handleSelect: _react.PropTypes.func,
  className: _react.PropTypes.string.isRequired,
  labelledById: _react.PropTypes.string.isRequired,
  labelLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
  descriptionLocalizedText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.node]),
  dropdownMenuId: _react.PropTypes.string,
  disableMobile: _react.PropTypes.bool,
  mountAsOpen: _react.PropTypes.bool,
  testId: _react.PropTypes.string,
  disabled: _react.PropTypes.bool,
  renderTrigger: _react.PropTypes.func
};

Dropdown.defaultProps = {
  className: 'btn-default',
  dropup: false,
  right: false,
  isLoading: false,
  labelledById: _lodash2.default.uniqueId('dropdown_'),
  disableMobile: false,
  mountAsOpen: false,
  renderSelected: function renderSelected(selected) {
    return _react2.default.createElement(
      'span',
      { className: 'selected-wrapper' },
      _react2.default.createElement(
        'span',
        { className: 'selected-value' },
        selected
      ),
      _react2.default.createElement(_baseIcons.Arrows.medium.Down, { className: 'selected-icon extra-small' })
    );
  }
};

exports.default = Dropdown;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-dropdown/lib/components/dropdown/components/Dropdown.component.js
// module id = 629
// module chunks = 0 1 9 10 11